import Reports from '@src/main/modules/reports/ui/components/Reports';

const ReportsPage = () => <Reports />;

export default ReportsPage;
